import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from 'react-redux';
import { clearCart } from "../../../store/reducers/cart-slice-reducer";
import { toast } from "react-toastify";
import axios from "axios";

// ✅ FIXED: Properly destructure props to receive sellerId and other data
export default function CheckoutForm({ stripeData, sellerId, productSku, cart }) {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentReady, setPaymentReady] = useState(false);
  const authInfo = useSelector(state => state.auth.authInfo);
  const userId = authInfo.id;

  const remove = () => {
    dispatch(clearCart());
    clearCartOfdatabase(userId);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      toast.error("Stripe.js has not loaded yet. Please wait.");
      return;
    }

    if (!paymentReady) {
      toast.error("Payment form is still loading. Please wait a moment.");
      return;
    }

    const paymentElement = elements.getElement("payment");
    if (!paymentElement) {
      toast.error("Payment form is not ready. Please refresh the page.");
      return;
    }

    setIsLoading(true);

    const { error: submitError } = await elements.submit();
    if (submitError) {
      toast.error(submitError.message || "Please check your payment details.");
      setMessage(submitError.message);
      setIsLoading(false);
      return;
    }

    // Always match the origin the buyer is currently logged into (e.g. pay.earth vs www.pay.earth)
    const baseReturnUrl =
      process.env.REACT_APP_CHECKOUT_RETURN_URL ||
      `${window.location.origin}/checkOutCompletePage`;

    // Include sellerId in return URL as query parameter for additional safety
    const returnUrl = sellerId
      ? `${baseReturnUrl}?sellerId=${sellerId}`
      : baseReturnUrl;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
        // ✅ ADD: Include additional metadata in payment confirmation
        payment_method_data: {
          metadata: {
            sellerId: sellerId || 'unknown',
            userId: userId,
            //cartData: JSON.stringify(cart || [])
          }
        }
      },
    });

    if (error) {
      console.error("Payment confirmation error:", error);

      if (error.type === "card_error" || error.type === "validation_error") {
        toast.error(error.message);
        setMessage(error.message);
      } else {
        toast.error("An unexpected error occurred.");
        setMessage("An unexpected error occurred.");
      }
      setIsLoading(false);
      return;
    }

    // Clear cart only after successful payment confirmation
    remove();
  };

  const clearCartOfdatabase = async (userId) => {
    try {
      const response = await axios.delete('user/clearfromcart', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${authInfo.token}`
        },
        data: {
          userId: userId
        }
      });
    } catch (error) {
      console.error("❌ Error clearing cart from database:", error);
      if (error.response) {
        console.log('error.response', error.response);
      }
    }
  };

  const paymentElementOptions = {
    layout: "tabs"
  };

  return (
    <>
      <div id="payment-element-container">
        <PaymentElement
          id="payment-element"
          options={paymentElementOptions}
          onReady={() => setPaymentReady(true)}
          onLoadError={(event) => {
            setPaymentReady(false);
            const msg = event?.error?.message || "Failed to load payment form.";
            toast.error(msg);
            setMessage(msg);
          }}
        />

        <div className="d-grid gap-2 col-6 mx-auto mt-4">
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleSubmit}
            id="pay-button"
            disabled={isLoading || !stripe || !elements || !paymentReady}
          >
            {isLoading ? "Processing..." : paymentReady ? "Pay Now" : "Loading payment…"}
          </button>
        </div>

        {message && <div id="payment-message">{message}</div>}
      </div>
    </>
  );
}
